/** En-tête commun : titre cliquable et « ← Accueil » (masqué sur l'accueil). */
import { h } from './dom';

export function renderTopbar(topbar: HTMLElement, visible: boolean, onHome: () => void): void {
  topbar.hidden = !visible;
  if (!visible) {
    topbar.replaceChildren();
    return;
  }
  const brand = h('a', { class: 'brand', href: '#/', testid: 'nav-brand' }, 'Barbichette');
  const home = h(
    'button',
    { type: 'button', class: 'button secondary small', testid: 'nav-home' },
    '← Accueil',
  );
  for (const el of [brand, home]) {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      onHome();
    });
  }
  topbar.replaceChildren(
    h('nav', { class: 'topbar-inner', 'aria-label': 'Navigation' }, brand, home),
  );
}
